import React, { useMemo, useState } from 'react';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getRegionSelectedData } from '../NewFilter/util';


interface Props {
  className: string
  value?: {
    category: string[]
    product: string[]
    category_type: 'category' | 'product'
  }
  activeTab?: 'common' | 'popular'
  locale?: 'en-US' | 'zh_CN'
  eventLoading?: boolean
  eventError?: boolean
  regionCountry?: any[]
  globalMessageHidden?: boolean
  globalMsg?: string
  onTabChange?: (activeTab?: 'common' | 'popular') => void
  onChange?: (value: any,options: any) => void
  onClose?: (value: any) => void
}

const EventSelectFilter = (props: Props) => {
  const {
    className,
    value: propsValue,
    regionCountry,
    locale,
    globalMsg = '',
    globalMessageHidden = false,
    activeTab = 'common',
    eventLoading,
    eventError,
    onTabChange,
    onChange,
    onClose,
  } = props;
  const [isHover, setIsHover] = useState(false);
  const hiddenList = ['all', '255'];
  const value = useMemo(() => {
    return {
      markets: propsValue?.event,
      regions: propsValue?.type,
      region_type: propsValue?.eventType === 'evnetType' ? 'region' : 'market',
    }
  }, [propsValue])

  const radioOptions = [
    {
      value: '255',
      text: 'All',
      textCN: '全部',
      infoIcon: <span style={{ display: 'flex', alignItems: 'center' }}
        onMouseOver={() => { setIsHover(true) }} onMouseOut={() => { setIsHover(false) }}
      >
        <>
          {
            !globalMessageHidden ? (
              <Bubble
                style={{
                  // width: 350,
                  left: -18,
                }}
                placement='bottom-start'
                content={globalMsg}
                dark
              >
                {/* 此处必须包一层，不然点击不生效 */}
                <i><SvgIcon className='select-header-ic' type={isHover ? 'alert-circle-action' : 'alert-circle-m'} /></i>
              </Bubble>
            ) : null
          }
        </>
      </span>
    }
  ];

  // 对数据格式进行处理，修改为新国家筛选器的格式
  const regionCountryOption = useMemo(() => {
    return regionCountry?.map((item, typeIndex) => {
      const itemObjChildren = item?.country?.map((items: { enText: any; chText: any; }, nameIndex: any) => {
        // 注意中英文和value的值（value有没有是英文名的特殊情况）
        return {
          ...items,
          text: items?.enText,
          textCN: items?.chText,
          // 后端反馈无法针对事件添加id，所以前端这里自己处理唯一key：typeIndex}_${typeIndex}_${item?.region_abbre
          // value: isEn ? `${items?.enText}_event_name_value_${typeIndex}_${nameIndex}_${item?.region_abbre}` : `${items?.chText}_event_name_value_${typeIndex}_${nameIndex}_${item?.region_abbre}`,
          // value: `${items?.[isEn ? 'enTex' : 'chText']}`
          value:`${items?.enText}_event_name_value_${typeIndex}_${nameIndex}_${item?.region_abbre}`
        }
      })
      // 地区筛选器组件内部region_key和value都是字符串类型的，在这里转换一下，不然选中的时候拿不到type值
      // 另外和后端确认过，这个地方接口返回的下拉id是int类型，但是在页面中传参需要给其他接口传字符串类型
      return {
        ...item,
        region_key: item?.item?.toString(),
        country: itemObjChildren,
        children: itemObjChildren,
        // 当前和后端核对只有英文有数据
        text: item?.region_name_en,
        textCN: item?.region_name_en,
        value: item?.region_abbre?.toString(),
      }
    })?.filter(item => !hiddenList.includes(item?.region_abbre?.toString()))
  }, [regionCountry])

  const resultValue = useMemo(() => {
    return getRegionSelectedData(regionCountryOption, value, true)
  }, [value, regionCountry])

  const handleNewConfirm = (value: any) => {
    onClose && onClose?.(value)
  }

  const language = {
    en: {
      'button_region': 'Event',
      'button_market': 'Event',
      'region_title': 'Event Type',
      'country_no_data': 'Sorry, there are no events for the currently selected date',
    },
    cn: {
      'button_region': '事件',
      'button_market': '事件名称',
      'region_title': '事件类型',
      'country_no_data': '抱歉，当前所选日期暂无事件',
    }
  }

  return (
    <>
      {
        <NewRegionSelect
          language={language}
          value={resultValue}
          className={className}
          selectFilterType='event_type'
          dropdownClassName='region-selector-dropdown'
          radioOptions={radioOptions}
          loading={eventLoading}
          error={eventError}
          options={regionCountryOption || []}
          onCloseReginSelect={handleNewConfirm}
          onChange={(value) => {
            onChange?.(value,regionCountryOption);
            handleNewConfirm(value);
          }}
          closeOnScroll={true}
          popularList={[]}
          locale={locale}
          activeTab={activeTab}
          onTabChange={onTabChange}
        />
      }

    </>
  )
}

export default EventSelectFilter;
